/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { EScheduleColumns } from './tableScheduleTypes';

/** Таблица идентична по составу полей таблице автоотчётов,
 * но должна быть растянута на ширину конструктора отчётов.
 * Задаём размеры столбцов таблицы с фронта,  чтобы не дублировать сущность на беке */

export const tableScheduleCellConfig: { [Key in EScheduleColumns]: number } = {
    description: 280,
    orderAttrType: 200,
    periodType: 130,
    report: 200,
    reportFormat: 130,
    startTime: 180,
    remove: 120,
};
